export default __webpack_public_path__ + "static/media/welcome-ip.4cf502e2.webp";